import { render, staticRenderFns } from "./NewAlertEntry.vue?vue&type=template&id=3f64a55e&scoped=true&"
import script from "./NewAlertEntry.vue?vue&type=script&lang=js&"
export * from "./NewAlertEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewAlertEntry.vue?vue&type=style&index=0&id=3f64a55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64a55e",
  null
  
)

export default component.exports